import { connect } from 'react-redux';
import { getGiftCardAmount } from '../selectors';

export default connect(
  state => ({
    gcAmount: getGiftCardAmount(state),
  }),
);



// WEBPACK FOOTER //
// ./src/app/giftCard/hoc/withGiftCardAmount.js